import React from 'react';
import { OUTREACH_COPY } from '../copy';
import s from '../s.module.less';

type Props = {
    // 有 cash price（listing 发布价）→ 转 self-pay 结尾；否则取消 + 帮患者另找结尾
    hasCashPrice: boolean;
};

// 二次失败 outreach strip（仅 managed，渲染在结果卡上方）：第一次失败什么都不加——
// Klarity 的自动轮还在跑；这条 strip 是「自动轮全部失败之后」的状态。
// 非 program 刻意没有对应物：repeat AAA 不计费、修复指引不变，「没有变化」就是正确答案
const OutreachStrip: React.FC<Props> = ({ hasCashPrice }) => (
    <div className={s.outreachStrip}>
        <svg
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="10" cy="10" r="8" />
            <path d="M10 9v4.5M10 6.2v.2" />
        </svg>
        <span>
            <b>{OUTREACH_COPY.lead}</b> {OUTREACH_COPY.ask}{' '}
            {hasCashPrice ? OUTREACH_COPY.endingCash : OUTREACH_COPY.endingNoCash}
        </span>
    </div>
);

export default OutreachStrip;
